<script setup>
import { computed } from 'vue';

const props = defineProps({
  label: { type: String, required: true },
  value: { type: Number, required: true },
  max: { type: Number, required: true },
});

const percent = computed(() => {
  if (!props.max || !props.value) return 0;
  return Math.max(4, Math.round((props.value / props.max) * 100));
});
</script>

<template>
  <div class="py-1.5">
    <div
      class="flex justify-between text-xs uppercase tracking-wide text-n-slate-11 mb-1"
    >
      <span>{{ label }}</span>
      <span class="font-bold text-n-slate-12">{{ value }}</span>
    </div>
    <div class="h-3 w-full bg-n-slate-4">
      <div class="h-3 bg-n-brand" :style="{ width: `${percent}%` }" />
    </div>
  </div>
</template>
